/*
 * @LastEditors: donsonwu
 * @Date: 2022-08-25 15:59:18
 * @LastEditTime: 2022-09-28 14:19:33
 * @Descripttion: 
 */
interface checkResult {
  isLogin: boolean
  userInfo: string
}
import * as milo from '@tencent/milo-web'
import { plat, btnParam } from '../diyWork/config'

class SingleInstanceLoginService {
  public LoginManager:Promise<any>
  private loginType = 'index'
  static instance: SingleInstanceLoginService = null
  private oWegameParams = {
		clientId: '7019928272', //应用id
		redirectUri: 'https://cfhd.cf.qq.com/comm-htdocs/login/wegame_redirect.html', //回调地址
		railGameId: '2000797', //游戏id
		scope: 'openid profile', //作用域，可多选，空格分隔
		state: 'STATE', //防csrf
		lang: 'ZH_CN', //语言，默认为中文(ZH_CN) 
		extraParams: {},
	}
  private oWXParams = { 
		appId: 'wx4a6848ac08e18340', //游戏在微信的appid，默认为腾讯游戏活动号
		gameDomain: 'cfhd.cf.qq.com', // 微信开放平台管理端里登记的回调域
		redirectUri: '', //授权页面，默认为系统默认的comm-htdocs/login/milosdk/wx_mobile_redirect.html
		// sUrl: '', //授权成功返回的页面，默认为当前页面
		scope: 'snsapi_userinfo', //默认静默授权
		lang: 'zh_CN', //返回的用户信息中省市的语言版本
		// openlink: '', //openlink，如果设置了，则在处理微信登录的时候，会从第三方跳到微信中
	}
  private btnParam = btnParam
  constructor(type: string) {
    this.loginType = type
    this.LoginManager = milo.Login.init({
      plat: plat, // 终端，可以选pc/mobile，默认pc
      oBtns: this.btnParam,
      commonParams:{
          iUseQQConnect: 1, // 是否使用qq互联登录态，0：不使用，1：使用，默认0
          isPrivateLogin: false, // 是否私有登陆态，如果为true，则不共享game.qq.com中的代理登录态，为false，则从game.qq.com中读取和写入登录态，默认为false
          useAppLogin:[]//是否使用多渠道原生登录能力，详见：http://ams.oa.com/document/wiki/#/about?iId=250&siId=1-409
      },
      logoutCallback:{
          freshWin:true, // 需要刷新页面（reload），不需要可以删除本行
          callback:function(){ // 初始化注销成功的回调逻辑
             // window.location.reload()
              console.log('logout!')
          },
      },
      mobileParams:{
        oWXParams: this.oWXParams
      },
      pcParams:{
        oWegameParams: this.oWegameParams
      },
      wxAvartarSize: 64,
    })
    this.setGlobalLogin()
  }
  // 单例模式
  public static getInstance (type: string) {
    if (!SingleInstanceLoginService.instance) {
      SingleInstanceLoginService.instance = new SingleInstanceLoginService(type)
    } 
    return SingleInstanceLoginService.instance
  }
  checkAndLogin () {
    return new Promise((resolve, reject) => {
      this.LoginManager.then((miloLoginSer) => {
        miloLoginSer.checkLogin().then((res: checkResult) => {
          resolve(res)
        }).catch((res: checkResult) => {
          // 去登录，删除后，会reject出错误情况
          this.toLogin()
          console.log('无登录态，走默认登录函数')
          // reject(res)
        })
      })
    })
  }
  setGlobalLogin() {
    this.LoginManager.then((miloLoginSer) => {
      //副作用，设置全局的登录状态
      miloLoginSer.setGlobalUnLogin(() => {
        this.toLogin()
      })
    })
  }
  toLogin() {
    this.LoginManager.then((miloLoginSer) => {
      if (this.loginType == 'nq') {
        // 拉起内嵌
        miloLoginSer.loginByWegame(this.oWegameParams)
      } else if(milo.platform.isWxApp()) {
        // wx拉起wx登录态
        miloLoginSer.loginByWX(this.oWXParams)
      } else if (this.loginType == 'H5') {
      // 拉起ptlogin登录态
        miloLoginSer.mobileLoginByQQConnect()
      } else {
        miloLoginSer.loginByQQConnect()
      }
    }).catch(() => {
      alert('登录初始化失败！')
    })
  }
}
export default SingleInstanceLoginService.getInstance